import request from '@/utils/request'

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/admin/api/users',
    method: 'get',
    params
  })
}

// 获取用户详情
export function getUserDetail(id) {
  return request({
    url: `/admin/api/users/${id}`,
    method: 'get'
  })
}

// 获取用户公开信息
export function getUserProfile(userId) {
  return request({
    url: '/api/users/profile',
    method: 'get',
    params: { userId }
  })
}

// 更新用户信息
export function updateUser(id, data) {
  return request({
    url: `/admin/api/users/${id}`,
    method: 'put',
    data
  })
}

// 更新用户状态
export function updateUserStatus(id, data) {
  return request({
    url: `/admin/api/users/${id}/status`,
    method: 'put',
    data
  })
}

// 更新用户信用额度
export function updateUserCreditLimit(id, creditLimit) {
  return request({
    url: `/admin/api/users/${id}/credit-limit`,
    method: 'put',
    data: { creditLimit }
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/admin/api/users/${id}`,
    method: 'delete'
  })
}